<template>
  <base-iframe
    height="100%"
    :params="{ canvas: 'true', currencyCode, model }"
    :src="`https://${origin}.vans.com/vfdp-${customsFlow ? 'customs-toolkit' : 'customizer-nora'}-${env}/index.html`"
    style="background: #f1f2ed"
    :title="$t.customs.title"
    width="100%"
    @message="({ data: { command } }) => $emit(command)"
  />
</template>

<script lang="ts" setup>
defineProps<{
  model?: string | string[]
  customsFlow?: string | string[]
}>()

defineEmits<{
  'close-iframe': []
  'customs-tool-loaded': []
  'customs-product-added-to-cart': []
}>()

const { targetEnv } = useRuntimeConfig().public
const currencyCode = getCurrencySymbol(useLocale(), useCurrencyCode())

const env = {
  DEV: 'dev',
  QA: 'qa2',
  PREPROD: 'preprod2',
  PROD: 'prod'
}[targetEnv]

const origin = {
  DEV: 'dev3',
  QA: 'qa3',
  PREPROD: 'preprod3',
  PROD: 'www'
}[targetEnv]
</script>
